// Mock data for unternehmenbewerten.ch

export const siteConfig = {
  name: "unternehmenbewerten.ch",
  tagline: "Unternehmenswert berechnen – Firma bewerten mit KI in der Schweiz",
  description: "Wir bieten einen innovativen, KI-gestützten Service zur Unternehmensbewertung, mit dem Sie den Unternehmenswert berechnen können – einfach, anonym und in wenigen Klicks.",
  cta: {
    primary: "Jetzt Unternehmenswert berechnen",
    secondary: "Beratung anfragen"
  }
};

export const navigationItems = [
  { label: "Unternehmensbewertung", href: "/unternehmensbewertung" },
  { label: "Verkaufen", href: "/unternehmen-verkaufen" },
  { label: "Kaufen", href: "/unternehmen-kaufen" },
  { label: "Über uns", href: "/ueber-uns" },
  { label: "Blog", href: "/blog" },
  { label: "Kontakt", href: "/kontakt" }
];

// NOTE: heroContent.headline MUST match SSG h1 in generate-static-pages.js (ROUTES['/'].h1)
// to ensure SSG <-> React parity and avoid H1 mismatch after hydration
export const heroContent = {
  badge: "KI-gestützte Bewertung",
  headline: "Unternehmensbewertung für Schweizer KMU",
  subheadline: "Wir bieten einen innovativen, KI-gestützten Service zur Unternehmensbewertung, mit dem Sie den Unternehmenswert berechnen können – einfach, anonym und in wenigen Klicks.",
  description: "Ideal für Unternehmerinnen und Unternehmer, die ihre Firma bewerten, ein Unternehmen verkaufen oder ein Unternehmen kaufen möchten.",
  ctaPrimary: "Jetzt Unternehmenswert berechnen",
  ctaSecondary: "Beratung anfragen",
  trustBadges: ["Kostenlos", "Anonym", "Ohne Registrierung"]
};

export const benefits = [
  {
    title: "KI-gestützte Bewertung",
    description: "Unternehmensbewertung mit künstlicher Intelligenz für präzise Ergebnisse.",
    icon: "Brain"
  },
  {
    title: "Für Schweizer KMU",
    description: "Entwicklung speziell für kleine und mittlere Unternehmen in der Schweiz.",
    icon: "Building2"
  },
  {
    title: "Vielseitig einsetzbar",
    description: "Geeignet für Firmenverkauf, Firmenkauf & Nachfolgeplanung.",
    icon: "Target"
  },
  {
    title: "Schnelle Ergebnisse",
    description: "Schnelle indikative Unternehmenswert-Berechnung in wenigen Minuten.",
    icon: "Zap"
  },
  {
    title: "Einfache Bedienung",
    description: "Keine Vorkenntnisse nötig – intuitive Benutzeroberfläche.",
    icon: "MousePointerClick"
  },
  {
    title: "Diskret & sicher",
    description: "Ihre Daten werden vertraulich behandelt und sicher verarbeitet.",
    icon: "Shield"
  }
];

export const processSteps = [
  {
    step: 1,
    title: "Daten eingeben",
    description: "Erfassen Sie grundlegende Unternehmensdaten und Kennzahlen."
  },
  {
    step: 2,
    title: "Branche wählen",
    description: "Wählen Sie Ihre Branche und relevante Vergleichsparameter."
  },
  {
    step: 3,
    title: "KI analysiert",
    description: "Unsere KI analysiert Markt & Vergleichswerte für Sie."
  },
  {
    step: 4,
    title: "Wert erhalten",
    description: "Erhalten Sie sofort Ihren indikativen Unternehmenswert."
  }
];

export const services = [
  {
    title: "Unternehmensbewertung",
    description: "Professionelle Bewertung mit verschiedenen Methoden: DCF, Ertragswert, Substanzwert.",
    href: "/unternehmensbewertung",
    icon: "Calculator",
    keywords: ["unternehmensbewertung schweiz", "firmenbewertung kmu"]
  },
  {
    title: "Firma verkaufen",
    description: "Begleitung beim Firmenverkauf – von der Bewertung bis zum erfolgreichen Abschluss.",
    href: "/unternehmen-verkaufen",
    icon: "TrendingUp",
    keywords: ["firma verkaufen schweiz", "unternehmen verkaufen kmu"]
  },
  {
    title: "Unternehmen kaufen",
    description: "Unterstützung beim Firmenkauf – faire Bewertung und Verhandlungsbegleitung.",
    href: "/unternehmen-kaufen",
    icon: "HandshakeIcon",
    keywords: ["unternehmen kaufen schweiz", "kmu kaufen"]
  },
  {
    title: "M&A Beratung",
    description: "Strategische M&A-Beratung für Transaktionen und Unternehmensnachfolge.",
    href: "/ma-beratung",
    icon: "Briefcase",
    keywords: ["m&a beratung schweiz", "m&a consulting"]
  }
];

export const faqItems = [
  {
    question: "Wie berechne ich den Wert meines Unternehmens?",
    answer: "Mit unserem kostenlosen Online-Tool können Sie in nur 3 Minuten eine indikative Unternehmensbewertung erhalten. Geben Sie Ihre Finanzkennzahlen ein (Umsatz, Gewinn, Eigenkapital), beantworten Sie qualitative Fragen zu Ihrem Unternehmen, und unsere KI berechnet automatisch eine Wertbandbreite basierend auf vier anerkannten Bewertungsmethoden."
  },
  {
    question: "Was kostet eine Unternehmensbewertung in der Schweiz?",
    answer: "Unsere Online-Erstbewertung ist komplett kostenlos und unverbindlich. Für eine professionelle, bankenfähige Bewertung mit detailliertem Gutachten variieren die Kosten je nach Komplexität zwischen CHF 3'000 und CHF 15'000. Kontaktieren Sie uns für ein individuelles Angebot."
  },
  {
    question: "Wie lange dauert eine Online-Unternehmensbewertung?",
    answer: "Die Online-Bewertung dauert nur etwa 3 Minuten. Sie beantworten einfache Fragen zu Ihrem Unternehmen und erhalten sofort eine indikative Wertbandbreite. Die detaillierte Analyse wird Ihnen zusätzlich per E-Mail zugestellt."
  },
  {
    question: "Welche Unterlagen brauche ich für die Bewertung?",
    answer: "Für die Online-Bewertung benötigen Sie lediglich grundlegende Finanzdaten: Jahresumsatz, Gewinn (EBIT oder Reingewinn), Eigenkapital und Fremdkapital. Diese Zahlen finden Sie in Ihrer Jahresrechnung oder Bilanz. Keine komplexen Dokumente erforderlich."
  },
  {
    question: "Welche Bewertungsmethoden werden verwendet?",
    answer: "Wir kombinieren vier bewährte Methoden: Die Ertragswertmethode (basierend auf zukünftigen Erträgen), die EBIT-Multiple-Methode (branchenübliche Multiplikatoren), die Substanzwertmethode (Bewertung der Vermögenswerte) und die Praktikermethode (kombinierter Ansatz nach Schweizer Standard). So erhalten Sie eine fundierte Bandbreite."
  },
  {
    question: "Ist die Online-Bewertung verbindlich oder rechtlich anerkannt?",
    answer: "Nein, die Online-Bewertung ist eine indikative Ersteinschätzung zur Orientierung. Sie eignet sich hervorragend für interne Diskussionen und erste Gespräche. Für Verhandlungen, Bankgespräche, Erbschaftsfragen oder rechtliche Zwecke empfehlen wir eine professionelle Bewertung durch unsere Experten."
  },
  {
    question: "Für welche Branchen ist die Bewertung geeignet?",
    answer: "Unser Tool ist für alle Schweizer KMU-Branchen optimiert: Dienstleistung, Handwerk, Handel, Gastronomie, IT, Gesundheitswesen, Produktion und viele mehr. Die Bewertung berücksichtigt branchenspezifische Multiplikatoren und Marktbedingungen."
  },
  {
    question: "Was beeinflusst den Unternehmenswert am meisten?",
    answer: "Die wichtigsten Werttreiber sind: Gewinnentwicklung und Stabilität, Kundenabhängigkeit (Klumpenrisiko), Qualität des Managements, Marktposition und Wettbewerbsvorteile, Wachstumspotenzial sowie übertragbare Prozesse. Wertbremsen wie hohe Inhaberabhängigkeit oder fehlende Dokumentation können den Preis deutlich senken."
  },
  {
    question: "Wann sollte ich mein Unternehmen bewerten lassen?",
    answer: "Eine Bewertung ist sinnvoll bei: Verkaufsabsichten oder Nachfolgeplanung, Einstieg von Investoren oder Partnern, Erbschafts- und Scheidungsangelegenheiten, strategischer Unternehmensplanung, Kreditverhandlungen mit Banken oder regelmässiger Überprüfung des Unternehmenswerts (z.B. jährlich)."
  },
  {
    question: "Was ist der Unterschied zwischen Ertragswert und Substanzwert?",
    answer: "Der Ertragswert berechnet, was das Unternehmen in Zukunft verdienen kann – er basiert auf Gewinnprognosen und ist oft höher bei profitablen Firmen. Der Substanzwert summiert alle Vermögenswerte (Maschinen, Immobilien, Lager) minus Schulden – er ist besonders relevant bei kapitalintensiven Unternehmen oder Liquidationen."
  },
  {
    question: "Wie kann ich den Wert meines Unternehmens steigern?",
    answer: "Wertsteigernde Massnahmen umfassen: Diversifizierung der Kundenbasis, Dokumentation aller Prozesse, Aufbau eines starken Management-Teams, Reduktion der Inhaberabhängigkeit, Steigerung der Gewinnmargen, Sicherung von langfristigen Kundenverträgen und Investitionen in Marke und Reputation."
  },
  {
    question: "Sind meine Daten bei der Bewertung sicher?",
    answer: "Ja, absolut. Ihre Daten werden verschlüsselt übertragen und streng vertraulich behandelt. Die Bewertung ist anonym möglich – wir benötigen keine Firmennamen für die Berechnung. Alle Daten werden gemäss Schweizer Datenschutzgesetz (DSG) verarbeitet."
  }
];

export const stats = [
  { value: "200+", label: "Bewertete Unternehmen" },
  { value: "10+", label: "Jahre Erfahrung" },
  { value: "CHF 400+ Mio.", label: "Transaktionsvolumen" },
  { value: "100%", label: "Von Unternehmern für Unternehmer" }
];

// Blog posts are now loaded from API - see BlogPreviewSection.jsx

export const footerLinks = {
  leistungen: [
    { label: "Unternehmensbewertung", href: "/unternehmensbewertung" },
    { label: "Unternehmen verkaufen", href: "/unternehmen-verkaufen" },
    { label: "Unternehmen kaufen", href: "/unternehmen-kaufen" },
    { label: "M&A Beratung", href: "/ma-beratung" }
  ],
  unternehmen: [
    { label: "Über uns", href: "/ueber-uns" },
    { label: "Referenzen", href: "/referenzen" },
    { label: "Blog", href: "/blog" },
    { label: "Kontakt", href: "/kontakt" }
  ],
  rechtliches: [
    { label: "Impressum", href: "/impressum" },
    { label: "Datenschutz", href: "/datenschutz" },
    { label: "AGB", href: "/agb" }
  ]
};

export const contactInfo = {
  company: "Schweizer Nachfolge Experten AG",
  companyLine2: "c/o unternehmenbewerten.ch",
  street: "Löwenstrasse 20",
  city: "8001 Zürich",
  address: "Schweizer Nachfolge Experten AG\nc/o unternehmenbewerten.ch\nLöwenstrasse 20\n8001 Zürich",
  phone: "+41 58 220 55 50",
  email: "info@unternehmenbewerten.ch"
};
